var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Bounding Box Small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,5 C10,4.07916667 10.7458333,3.33333333 11.6666667,3.33333333 C12.5875,3.33333333 13.3333333,4.07916667 13.3333333,5 C13.3333333,5.92083333 12.5875,6.66666667 11.6666667,6.66666667 C10.7458333,6.66666667 10,5.92083333 10,5 Z M16.6666667,1.66666667 L16.6666667,13.3333333 L16.6666667,15 C16.6666667,15.9208333 15.9208333,16.6666667 15,16.6666667 L1.66666667,16.6666667 C0.745833333,16.6666667 0,15.9208333 0,15 L0,10 L0,1.66666667 C0,0.745833333 0.745833333,0 1.66666667,0 L15,0 C15.9208333,0 16.6666667,0.745833333 16.6666667,1.66666667 Z M15,1.66666667 L1.66666667,1.66666667 L1.66666667,7.98833333 L4.41083333,5.24416667 C4.58166667,5.07333333 4.82,4.98916667 5.05916667,5.00166667 C5.3,5.01916667 5.52166667,5.14 5.66666667,5.33333333 L10,11.1108333 L11.8333333,8.66666667 C11.9883333,8.46083333 12.2291667,8.3375 12.4866667,8.33333333 C12.7341667,8.33666667 12.99,8.445 13.1508333,8.64583333 L15,10.9575 L15,1.66666667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MLP-deliverables",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-/-Icon-/-Small-/-Mobile-Copy-3",
    transform: "translate(-11.000000, -11.564972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Bounding-Box-Small",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "//-Base",
    fillOpacity: 0,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.666667, 1.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u21B3-icon-tint",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    x: -1.66666667,
    y: -1.66666667,
    width: 20,
    height: 20
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImage);
export default __webpack_public_path__ + "static/media/ic_image.7eabc1705694d10b2b02f724b114da50.svg";
export { ForwardRef as ReactComponent };